import React, { useState } from "react";
import { Tag } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import styles from "./Inventory.module.css";

const InventoryMobileCard = ({
  record,
  primaryFields = [],
  secondaryFields = [],
  renderCell,
}) => {
  const [expanded, setExpanded] = useState(false);

  const getValue = (key) => {
    const raw = record[key];
    if (renderCell) {
      const custom = renderCell(key, raw, record);
      if (custom !== undefined) return custom;
    }
    return raw ?? "—";
  };

  const badgeClass = {
    tagno: styles.badgeTagno,
    purity: styles.badgePurity,
    pieces: styles.badgePieces,
    grosswt: styles.badgeGrosswt,
    lesswt: styles.badgeLesswt,
    netwt: styles.badgeNetwt,
  };

  return (
    <div className={styles.mobileCard}>
      {/* ── Primary fields grid ── */}
      <div className={styles.mobileCardPrimary}>
        {primaryFields.map((f) => (
          <div className={styles.mobileCardField} key={f.key}>
            <span className={styles.mobileCardLabel}>{f.label}</span>
            {f.badge ? (
              <span
                className={`${styles.mobileBadge} ${badgeClass[f.badge] ?? ""}`}
              >
                {getValue(f.key)}
              </span>
            ) : (
              <span className={styles.mobileCardValue}>{getValue(f.key)}</span>
            )}
          </div>
        ))}
      </div>

      {/* ── Secondary fields (collapsible) ── */}
      {secondaryFields.length > 0 && (
        <>
          <button
            className={styles.mobileCardToggle}
            onClick={() => setExpanded((e) => !e)}
          >
            {expanded ? (
              <>
                <UpOutlined style={{ fontSize: 9 }} /> Hide details
              </>
            ) : (
              <>
                <DownOutlined style={{ fontSize: 9 }} /> More details
              </>
            )}
          </button>

          <div
            className={`${styles.mobileCardSecondary} ${
              expanded ? styles.mobileCardSecondaryOpen : ""
            }`}
          >
            {secondaryFields.map((f) => (
              <div className={styles.mobileCardSecondaryRow} key={f.key}>
                <span className={styles.mobileCardSecondaryLabel}>
                  {f.label}
                </span>
                <span className={styles.mobileCardSecondaryValue}>
                  {getValue(f.key)}
                </span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default InventoryMobileCard;
